// 📧 src/services/emailReadService.ts

interface EmailConfig {
  server: string;
  username: string;
  password: string;
  imapPort: number;
  ssl: boolean;
}

export class EmailReadService {
  private static instance: EmailReadService;
  
  static getInstance(): EmailReadService {
    if (!EmailReadService.instance) {
      EmailReadService.instance = new EmailReadService();
    }
    return EmailReadService.instance;
  }

  /**
   * Marcar emails como leídos o no leídos
   */
  async markEmailsReadStatus(
    emailConfig: EmailConfig,
    folderPath: string,
    emailUids: number[],
    markAsRead: boolean
  ): Promise<{ success: boolean; message?: string; error?: string }> {
    try {
      console.log(`📧 Marking ${emailUids.length} emails as ${markAsRead ? 'read' : 'unread'}`);

      const response = await fetch('https://backend.anubisai.net/api/pmail/mark-read', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          server: emailConfig.server,
          username: emailConfig.username,
          password: emailConfig.password,
          imapPort: emailConfig.imapPort,
          ssl: emailConfig.ssl,
          folderPath,
          emailUids,
          markAsRead
        })
      });

      const result = await response.json();

      if (response.ok && result.success) {
        console.log(`✅ Email read status updated: ${result.message}`);
        return {
          success: true,
          message: result.message
        };
      } else {
        throw new Error(result.error || 'Error al actualizar estado de lectura');
      }
    } catch (error: any) {
      console.error('❌ Error updating read status:', error);
      return {
        success: false,
        error: error.message
      };
    }
  }

  /**
   * Marcar como leído
   */
  async markAsRead(emailConfig: EmailConfig, folderPath: string, emailUids: number[]) {
    return this.markEmailsReadStatus(emailConfig, folderPath, emailUids, true);
  }

  /**
   * Marcar como no leído
   */
  async markAsUnread(emailConfig: EmailConfig, folderPath: string, emailUids: number[]) {
    return this.markEmailsReadStatus(emailConfig, folderPath, emailUids, false);
  }

  /**
   * Alternar estado de lectura
   */
  async toggleReadStatus(emailConfig: EmailConfig, folderPath: string, emailUid: number, currentlyRead: boolean) {
    return this.markEmailsReadStatus(emailConfig, folderPath, [emailUid], !currentlyRead);
  }
}

// 🔧 Función helper para obtener config
export const getEmailConfig = (): EmailConfig | null => {
  try {
    const stored = localStorage.getItem('emailConfig');
    return stored ? JSON.parse(stored) : null;
  } catch (error) {
    console.error('Error getting email config:', error);
    return null;
  }
};
